import { query, post } from '@/services/api/backendGateway'

const TERMS_API = '/terms/'

export async function getTermsStatus() {
  return (await query(TERMS_API)) || {}
}

export function acceptTerms() {
  return post(TERMS_API)
}
